var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.205,
    height: 16.236,
    viewBox: "0 0 16.205 16.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    "data-name": "Icon feather-phone",
    d: "M18.372,14.406V16.7a1.529,1.529,0,0,1-1.667,1.529,15.129,15.129,0,0,1-6.6-2.347,14.907,14.907,0,0,1-4.587-4.587A15.129,15.129,0,0,1,3.174,4.666,1.529,1.529,0,0,1,4.7,3H6.989A1.529,1.529,0,0,1,8.518,4.315a9.816,9.816,0,0,0,.535,2.148,1.529,1.529,0,0,1-.344,1.613l-.971.971a12.231,12.231,0,0,0,4.587,4.587l.971-.971a1.529,1.529,0,0,1,1.613-.344,9.816,9.816,0,0,0,2.148.535,1.529,1.529,0,0,1,1.315,1.552Z",
    transform: "translate(-2.667 -2.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.9e3a0b4a74cdea17b08a176ddb3f323f.svg";
export { ForwardRef as ReactComponent };